import gql from 'graphql-tag';

export const UPDATE_CREATIVE_TEMPLATE_MUTATION = gql`
  mutation UpdateCreativeTemplateMutation(
    $imageOrVideoCreativeTemplateInput: ImageOrVideoCreativeTemplateUpdateInput!
  ) {
    updateCreativeTemplate(imageOrVideoCreativeTemplateInput: $imageOrVideoCreativeTemplateInput) {
      imageOrVideoCreativeTemplate {
        id
        sourceType
        callToAction
        postText {
          id
          text
        }
        headline {
          id
          text
        }
        description {
          id
          text
        }
      }
      errors
    }
  }
`;
